import instObj from '@/backend/axios-instances'

const resource = "/boms/detail"
const instance = instObj.baseInstance

export default {
  get(detailId, parameters) {
    return instance.get(`${resource}/${detailId}`, { params: parameters });
  },
  put(detailId, data, parameters) {
    return instance.put(`${resource}/${detailId}`, data, { params: parameters });
  },
  delete(detailId) {
    return instance.delete(`${resource}/${detailId}`);
  }
}
